import { Linkedin, Mail, Phone } from "lucide-react";

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-xl bg-white text-slate-900 grid place-items-center font-display font-bold text-sm tracking-tight">AI</div>
            <div className="leading-tight">
              <div className="font-display font-bold text-white text-[16px]">The AI Growth Pilot</div>
              <div className="text-[10px] uppercase tracking-widest text-blue-400 font-semibold">SEO • Paid Ads • AI Automation</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
            Premium growth marketing for businesses that want more traffic, leads and revenue —
            with SEO, paid ads and AI-powered automation.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href="https://www.linkedin.com/in/vipul-k-saxena-0b0077175/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
              className="w-10 h-10 rounded-full border border-slate-700 hover:border-blue-500 hover:text-blue-400 grid place-items-center transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-white font-display font-semibold mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            {[
              ["Home", "#home"],
              ["Services", "#services"],
              ["Results", "#results"],
              ["Process", "#process"],
              ["Packages", "#packages"],
              ["FAQ", "#faq"],
            ].map(([l, h]) => (
              <li key={l}>
                <a href={h} className="hover:text-white transition-colors">
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white font-display font-semibold mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-blue-400" />
              <a href="mailto:hello@vipulsaxena.com" className="hover:text-white">hello@vipulsaxena.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-blue-400" />
              <span className="text-slate-400">Available on request</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {year} The AI Growth Pilot. All rights reserved.</div>
          <div>Built for businesses that take growth seriously.</div>
        </div>
      </div>
    </footer>
  );
}
